import React from 'react';

function Footer() {
  return (
    <footer>
      <img src="/img/logo.png" style={{ marginLeft: '50px' }} alt="Logo" />
      <div className="footer-contents">
        <p>Designed and developed with <br /> <span style={{ display: 'inline-block', WebkitTransform: 'rotate(-180deg)' }}>♥</span> from down under. 🇦🇺</p> 
      </div>
    </footer>
  );
}

export default Footer; 